"use client";

import React, { useEffect, useRef } from "react";
import { cn } from "../../../../Applications/OnClicks/src/utilities/ui";

import type { Props as MediaProps } from "../../../../Applications/OnClicks/src/types/Media";

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { onClick, resource, videoClassName } = props;

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const { current: video } = videoRef;
    if (video) {
      video.addEventListener("suspend", () => {});
    }
  }, []);

  if (resource && typeof resource === "object") {
    return (
      <video
        autoPlay
        className={cn(videoClassName)}
        controls={false}
        loop
        muted
        onClick={onClick}
        playsInline
        ref={videoRef}
      >
        <source src={`${resource.url}`} type="video/mp4" />
      </video>
    );
  }

  return null;
};
